import { IonItem, IonList, IonSkeletonText } from '@ionic/react';

import classes from './style.module.scss';

const ListLoader = () => {
  return (
    <div className={classes.ionSlideSkelton}>
      <div className={classes.fuelingPlanTitleHead}>
        <IonSkeletonText style={{ width: '100%', height: '100%' }} animated />
        <div className={classes.fuelingPlanInfoContainer}>
          <div className={classes.fuelingPlanCategory}>
            <IonSkeletonText style={{ width: 200, height: 30 }} animated />
          </div>
          <div className={classes.fuelingPlanNameNotes}>
            <IonSkeletonText
              style={{ width: '100%', height: '100%' }}
              animated
            />
          </div>
        </div>
      </div>
      <div className={classes.fuelingPlanDecWorkouts}>
        <div>
          <IonSkeletonText animated style={{ height: 30 }} />
        </div>
        <div className={classes.fuelingPlanWorkouts}>
          <IonList lines='none'>
            <IonItem color='primary'>
              <IonSkeletonText animated style={{ height: 30 }} />
            </IonItem>
            <IonItem color='primary'>
              <IonSkeletonText animated style={{ height: 30 }} />
            </IonItem>
            <IonItem color='primary'>
              <IonSkeletonText animated style={{ height: 30 }} />
            </IonItem>
            <IonItem color='primary'>
              <IonSkeletonText animated style={{ height: 30 }} />
            </IonItem>
            <IonItem color='primary'>
              <IonSkeletonText animated style={{ height: 30 }} />
            </IonItem>
            <IonItem color='primary'>
              <IonSkeletonText animated style={{ height: 30 }} />
            </IonItem>
          </IonList>
        </div>
      </div>
    </div>
  );
};

export default ListLoader;
